import { render } from "./BlocksColoredInfo.vue?vue&type=template&id=49936b08&scoped=true"
import script from "./BlocksColoredInfo.vue?vue&type=script&lang=js"
export * from "./BlocksColoredInfo.vue?vue&type=script&lang=js"

import "./BlocksColoredInfo.vue?vue&type=style&index=0&id=49936b08&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49936b08"]])

export default __exports__